import { render, staticRenderFns } from "./CloudSupplierOrg.vue?vue&type=template&id=b22d4a5a&"
import script from "./CloudSupplierOrg.vue?vue&type=script&lang=js&"
export * from "./CloudSupplierOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports